export default {
  setSmsInputView(state, value) {
    state.smsInputView = value
  },
  setEmailConfirmedMessage(state, value) {
    state.emailConfirmedMessage = value
  },
}
